import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "@css/index.css";
import "@css/styles.css";

import Header from "@components/Header.jsx";
import Home from "@pages/home/page.jsx";
import Accounts from "@pages/accounts/page.jsx";
import Proxy from "@pages/proxy/page.jsx";
import TaskSpeedsPage from "@pages/task/task_speeds.jsx";
import TaskAccountsPage from "@pages/task/task_accounts.jsx";
import TaskProxiesPage from "@pages/task/task_proxies.jsx";
import Login from "@pages/login/page.jsx";

import ProtectedRoute from "@components/ProtectedRoute.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <>
                <Header className="fixed top-0 left-0 right-0 z-50" />
                <div>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/accounts" element={<Accounts />} />
                    <Route path="/proxy" element={<Proxy />} />
                    <Route path="/tasks/:uid/accounts" element={<TaskAccountsPage />} />
                    <Route path="/tasks/:uid/proxies" element={<TaskProxiesPage />} />
                    <Route path="/tasks/:uid/speeds" element={<TaskSpeedsPage />} />
                    <Route path="*" element={<Home />} />
                  </Routes>
                </div>
              </>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
